import React, { useEffect, useState } from "react";
import { language } from "../../system/types/project/language";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import {useTranslations} from "../../hooks/useTranslations";


interface props {
    name: string,
    value: language,
    label?: string,
    excluded?: string[],
    onChange: (changeValue: language) => void
}


const LanguageSelector = (props: props) => {
    const { t } = useTranslations();

    const groupTextId = props.name + 'label';
    const inputId = props.name + '-input';

    const [inputValue, setInputValue] = useState<language>(props.value);
    const [inputLabel, setInputLabel] = useState<string>('');
    const [languages, setLanguages] = useState<language[]>([]);
    const [showLanguages, setShowLanguages] = useState<language[]>([]);


    useSelector((state: RootState) => {
        if (state.system.languages !== languages) {
            setLanguages(state.system.languages);
        }
    });

    const handleChange = (event: any) => {
        const newValue = event.target.value;

        languages.forEach((entry) => {
            if (entry.isoCode === newValue) {
                props.onChange(entry);
                setInputValue(entry);
            }
        });
    };

    useEffect(() => {
        if (typeof props.label !== 'undefined') {
            setInputLabel(props.label);
        }
        setInputValue(props.value);
    }, [props]);

    useEffect(() => {

        const list: language[] = [];

        languages.forEach((language) => {
            if (typeof props.excluded !== 'undefined' && props.excluded.includes(language.isoCode)) {
                return;
            }
            list.push(language);
        });

        setShowLanguages(list);

    }, [languages, props.excluded])

    return (
        <div className="input-group formElement">
            <label className="input-group-text" id={groupTextId}>{inputLabel}</label>
            <select
                id={inputId}
                name={inputId}
                className="form-control"
                aria-label={inputLabel}
                aria-describedby={groupTextId}
                onChange={handleChange}
                value={inputValue.isoCode}
            >
                {props.value.isoCode === '' ?
                    <option key="" value="">{t('projects.selectalanguage')}</option>
                    : null}
                {showLanguages.map(language => (
                    <option key={language.isoCode} value={language.isoCode}>
                        {language.name}
                    </option>
                ))}
            </select>
        </div>
    );
}

export { LanguageSelector };
